import { Box, Stack, SvgIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CollapsibleCard } from '../../molecules/CollapsibleCard';

export const CollapsibleCardStyled = styled(CollapsibleCard)(() => ({
	padding: 0,
}));

export const VouchersForm = styled('div')(() => ({
	display: 'grid',
	gridAutoRows: 'max-content',
	gridTemplateColumns: '1fr max-content',
	gridTemplateAreas: `
		"input       submit"
		"validation  validation"
		`,
	gap: '12px 8px',
}));

export const VouchersFormInput = styled('div')(() => ({
	gridArea: 'input',
	'& > div': {
		width: '100%',
	},
}));

export const VouchersValidation = styled(Stack)(() => ({
	gridArea: 'validation',
}));

export const VouchersFormSubmit = styled('div')(() => ({
	gridArea: 'submit',
}));

export const SvgIcon20 = styled(SvgIcon)(() => ({
	fontSize: 20,
})) as unknown as typeof SvgIcon;

export const VoucherFormRow = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: 12,
}));

export const VoucherChipRow = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
}));
